import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { color } from '../../app/theme';
import Tooltip from '../shared/Tooltip';

const useStyles = makeStyles(
  {
    root: {
      paddingBottom: 12,
    },
    line: {
      flexGrow: 1,
      borderBottom: `1px solid ${color.$9}`,
    },
    text: {
      margin: '0 16px',
      maxWidth: '80%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
      color: color.$11,
    },
    order: { display: 'flex', alignItems: 'center', marginBottom: 44 },
  },
  {
    name: 'PreviewMANode',
  },
);

const PreviewMANode = ({ node }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { list } = useSelector(store => store.ma);
  const { data } = node || {};
  const { procedureId } = data || {};
  const { name } = useMemo(
    () => list.find(n => n?.id === procedureId) || {},
    [list],
  );

  return (
    <div className={classes.root}>
      <div className={classes.order}>
        <span className={classes.line} />
        <Tooltip light placement="top" title={name}>
          <span className={classes.text}>{t('preview.ma')}</span>
        </Tooltip>
        <span className={classes.line} />
      </div>
    </div>
  );
};

export default PreviewMANode;
